<template>
    <div class="curtain-grey">
        <div class="body-delete">
            <img src="../../../assets/images/Public/img-delete.png" alt="">
            <div class="border-delete">
                <div class="text-title">删除{{ moduleTitle }}</div>
                <div class="items" v-if="moduleTitle==='清单' && repeatState">
                    <div class="item" v-for="(item, index) in items">
                        <div class="my-cursor" :class="{
                        'icon-select': index !== selectedIndex,
                        'icon-selected': index === selectedIndex}"
                        @click.stop="selectItem(index)">
                        </div>
                        <div class="text-item">{{ item }}</div>
                    </div>
                </div>

                <div class="text-tip" v-else>确定要删除{{ moduleTitle }}吗？</div>
                <div class="button-items">
                    <div class="button-close my-cursor" @click.stop="close">取消</div>
                    <div class="button-submit my-cursor" @click.stop="submit">保存</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "DeleteCard",
    data(){
        return {
            selectedIndex: 0,
            items: [
                "仅删除这条清单",
                "仅删除这条以后的清单",
                "删除重复周期的所有清单",
            ],
            title: "清单",
        }
    },
    props: {
        moduleTitle: {
            type: String,
            default: "清单",
        },
        repeatState: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        close: function(){
            this.$emit("closeEvent");
        },
        submit: function(){
            this.$emit("submitEvent", this.selectedIndex);
            this.close();
        },
        selectItem: function(index){
            this.selectedIndex = index;
        },
    },
}
</script>

<style scoped>

div.body-delete{
    width: 4.72rem;
    height: auto;
    padding: 0.08rem;
    background: #FFFFFF;
    border-radius: 0.3rem;
    margin: 30vh auto auto;
}
div.body-delete img{
    width: 1.55rem;
    height: 1.03rem;
    display: block;
    margin: -1.11rem auto 0.08rem;
}
div.border-delete{
    width: 100%;
    height: auto;
    padding: 0.2rem 0.16rem 0.3rem;
    border: 0.02rem solid #000000;
    border-radius: 0.26rem;
    box-sizing: border-box;
}
div.text-title{
    font-weight: bold;
    font-size: 0.22rem;
    color: #000000;
    line-height: 0.26rem;
    text-align: center;
}
div.text-tip{
    font-weight: bold;
    font-size: 0.18rem;
    color: #000000;
    line-height: 0.22rem;
    text-align: center;
    margin-top: 0.16rem;
}
div.items{
    margin-top: 0.16rem;
}

div.item{
    width: 100%;
    height: 0.4rem;
    margin-bottom: 0.3rem;
    display: flex;
    align-items: center;
    gap: 0.1rem;
}

div.item:nth-last-of-type(1){
    margin-bottom: 0;
}
div.icon-select, div.icon-selected{
    width: 0.18rem;
    height: 0.19rem;
}
div.icon-select{
    background: url("../../../assets/images/Public/icon-select.png") no-repeat;
    background-size: cover;
}
div.icon-selected{
    background: url("../../../assets/images/Public/icon-selected.png") no-repeat;
    background-size: cover;
}

div.text-item{
    font-weight: bold;
    font-size: 0.18rem;
    color: #000000;
    line-height: 0.22rem;
    text-align: left;
}


div.button-items{
    width: 100%;
    height: 0.48rem;
    margin-top: 0.4rem;
    display: flex;
    box-sizing: border-box;
    padding: 0 0.34rem;
    justify-content: space-between;
}
div.button-submit, div.button-close{
    width: 1.4rem;
    height: 0.48rem;
    border-radius: 0.38rem;
    border: 0.02rem solid #000000;
    font-size: 0.16rem;
    line-height: 0.43rem;
    text-align: center;
}

div.button-close{
    background: #FFFFFF;
    box-shadow: inset 0 -0.05rem 0 0 #9F9F9F;
    color: #000000;
}
div.button-submit{
    background: #FC8470;
    box-shadow: inset 0 -0.05rem 0 0 #FFF4C9;
    color: #FFFFFF;
}
</style>